<script lang="ts">
	//Hooks
	import { beforeUpdate } from 'svelte';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Alert, Button, Icon, Select, Text, toast } from '@Shelly/shelly-design-system';
	//Componnets
	import ModalPrompt from '../../../../components/ModalPrompt.svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device;

	let calibration_options = [
		$format('chart_legend_phase_a'),
		$format('chart_legend_phase_b'),
		$format('chart_legend_phase_c'),
		$format('chart_legend_phase_n'),
	];

	let selectedFrom = calibration_options[1];
	let selectedTo = calibration_options[0];
	let showModal = false;
	let loading = false;
	$: disabled = selectedFrom === selectedTo || selectedFrom === calibration_options[3];

	let localIp = get_local_ip(device.id);
	let props;

	const calibrate = async () => {
		let res;
		loading = true;
		if (localIp) {
			res = await localReq(device, `${localIp}/calibrate`, 'post', {
				from: calibration_options.indexOf(selectedFrom) + 1,
				to: calibration_options.indexOf(selectedTo) + 1,
			});
		} else {
			res = await postReq(`/device/${device.category}/calibration`, {
				from: calibration_options.indexOf(selectedFrom) + 1,
				to: calibration_options.indexOf(selectedTo) + 1,
				id: device.id,
			});
		}

		if (res.isok) {
			toast.open({
				type: 'success',
				title:
					$format('phase_calibration_started_scc_toast', {
						values: {
							from: selectedFrom,
							to: selectedTo,
						},
					}) || `Phase {to} will calibrate from {from}.`,
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loading = false;
	};

	const factoryCalibrate = async () => {
		let res;

		if (localIp) {
			res = await localReq(device, `${localIp}/ct_restore_calibration`, 'post', {});
		} else {
			res = await postReq(`/device/${device.category}/restore_calibration`, {
				id: device.id,
			});
		}

		if (res.isok) {
			toast.open({
				type: 'success',
				title: $format('factory_calibration_scc', {
					default: `Factory calibration restored.`,
				}),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	beforeUpdate(() => {
		props = {
			//this check is needed here because otherwise modal doesn't change its text
			// TODO add translation label_confirmation
			title: `${$format('sub_settings_title_calibration')} ${capFirstChar(
				$format('title_reset_ai_model_short'),
			)}?`,
			button_1_variant: 'danger',
			button_1: capFirstChar($format('button_reset')),
			button_2: $format('button_cancel'),
			callback: factoryCalibrate,
		};
	});
</script>

<Alert
	type="warning"
	isHeadingBold
	heading={$format('label_info')}
	class="mb-s"
	message={$format('transformer_calibration_warning', {
		default:
			'Use this option ONLY if you have to replace the current transformer with a new one (supported only for 120A transformers provided by the manufacturer)!',
	})}
/>

<Text class="mb-s">
	{$format('calibrate_phase', { default: 'Calibrate phase:' })}
</Text>
<Select
	class="mb-s"
	bind:value={selectedTo}
	options={calibration_options}
	icon={'fas fa-microchip'}
	id="select-qkls28l"
	aria-label={$format('calibrate_phase', { default: 'Calibrate phase' })}
/>

<Text class="mb-s">
	{$format('calibrate_phase_from', { default: 'Calibrate it from phase:' })}
</Text>
<Select
	class="mb-s"
	bind:value={selectedFrom}
	options={calibration_options}
	icon={'fas fa-microchip'}
	id="select-zwc2drk"
	aria-label={$format('calibrate_phase_from', {
		default: 'Calibrate it from phase',
	})}
/>

<Button class="mb-s" {loading} size="m" width="full" {disabled} on:click={calibrate}
	>{$format('button_calibrate')}</Button
>

<Button variant="secondary" size="m" width="full" on:click={() => (showModal = true)}
	>{$format('button_restore_calibration_all', {
		default: 'Restore factory calibration(all phases)',
	})}</Button
>
{#if showModal}
	<ModalPrompt bind:showModal {props}>
		<div class="d-flex flex-direction-column align-items-center">
			<Icon icon="text-danger fak fa-light-factory-reset" size="xxl" />
			<Text class="mt-xs width-full">
				{$format('reset_phases_caluibration_alert', {
					default:
						'This will reset all phases calibration to factory settings. Are you sure you want to proceed?',
				})}
			</Text>
		</div>
	</ModalPrompt>
{/if}
